import React, { useRef, useState } from "react";
import { CreateLeadFooter, StyledCompanyContainer, StyledflexSpacebetween, StyledNormalContent } from "../../../Components/Styled";
import SelectBoxWithLabel from "../../../Components/SelectBoxWithLable";
import TextFiledWithLabel from "../../../Components/TextFieldWithLabel";
import { Box } from "@mui/system";
import { StyledSubHeader } from "../../../Components/Styled";
import {Button, Stack, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { requestHideLoader, requestShowLoader } from "../../../Store/Global/action";
import { createRequestData, dateFormatting, getRequestData,getEntityList ,requestDeleteApiCall, updateOrderRequestData, updateRequestData, userValidation } from "../../../Utility/apiHelper";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import {  requestgetcurrenctuser } from "../../../Store/User/action";
import RolePermissionComponenet from "../../../Components/RolePermissionComponent";
import { GridActionsCellItem } from '@mui/x-data-grid';
import { handleValidateCodevalue , ACTIVE_STATUS, commonTitles} from "../../../Utility/constant";
import { isValidEmail } from "../../../Utility/apiHelper";
import WhoColumnTextfieds from "../../../Components/WhoColumnTextfieds";
import AutoCompleteComponent from "../../../Components/AutoCompleteComponenet";
import CommonComm from "../../../Components/CommonComm";
import LeadAccordion from "../../../Components/LeadAccordion";
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import deleteIcon from '../../../Assets/images/trashIcon.png';
import disabledDeleteIcon from '../../../Assets/images/disabledTrashIcon.png';
import moment from "moment";


const CreateEditUser = ({isUserScreen = true, setIsViewMode , isViewMode ,handleEditApplication, handleCustomBackbutton, companyList, iscreateuser, allrolesData, isEdituser, currentuserid}) => {
    if(!isEdituser){
        setIsViewMode(false)
    }
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const today = new Date().toISOString().split('T')[0];
    const [userDetail, setUserdetails] = useState({
        validFrom : today,
        status : 'USER_STATUS_ACTIVE',
        selectedCompany : null,
        selectedManager : null
    });
    const [initialUserDetail,setIntialUserDetail] = useState(null);
    const [requiredValue, setRequiredvalue] = useState({})
    const [dataGridData, setdataGridData] = useState([]);
    

    const[selectedRoles, setSelectedRoles] = useState(null);
    const userStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'USER_STATUS')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
   
    const {enqueueSnackbar} = useSnackbar();

    const dispatch = useDispatch();

    const handleSelectMultiRoles = (event, roles, reason) => {
        setSelectedRoles(roles);
    }

    useEffect(() => {
        if(isEdituser) {
            getcurrentuserdetails();
            getcurrentUserrolesdetails();
        }
    },[isEdituser])

    const getcurrentuserdetails = async() => {
        dispatch(requestShowLoader());
        const url = `${process.env.REACT_APP_BASE_URL}users/${currentuserid}`;
        const responseData = await getRequestData(url);
        const filteredcompany = companyList?.find(item => item?.id == responseData?.data?.clientId);
        const updateUser = responseData?.data;
        const { validFrom, validTo, ...rest } = updateUser;
        setUserdetails({
            ...rest,
            "email" : updateUser?.userEmail,
            "phone" : updateUser?.mobile,
            validFrom : updateUser?.validFrom ? dateFormatting(updateUser?.validFrom) : "",
            validTo : updateUser?.validTo ? dateFormatting(updateUser?.validTo) : "",
            telephone: updateUser?.telephone,
            selectedCompany : filteredcompany,
    });
        setIntialUserDetail({
            ...rest,
            "email" : updateUser?.userEmail,
            "phone" : updateUser?.mobile,
            validFrom : updateUser?.validFrom ? dateFormatting(updateUser?.validFrom) : "",
            validTo : updateUser?.validTo ? dateFormatting(updateUser?.validTo) : "",
            telephone: updateUser?.telephone,
            selectedCompany : filteredcompany,
        })
        dispatch(requestHideLoader());
    }

    const getcurrentUserrolesdetails = async() => {
        
        const url = `${process.env.REACT_APP_BASE_URL}userroles`;
        const responseData = await getRequestData(url);
        const filteredPermission = responseData?.data?.map(item => {
            if(item?.user?.id == currentuserid) {
                return {
                    name:item?.role?.name,
                    id: item?.id,
                    roleId : item?.role?.id,
                };
            }}).filter(Boolean);
        setdataGridData(filteredPermission);
    }

    const resetRequiredState =()=>{
        setRequiredvalue({
             title:true,
            firstName: true,
            lastName: true,
            clientId: true,
            email: true,
            status:true,
            phone:true,
            validFrom:true,
            validTo:true
        })
    }
    const handleSaveUser = async() => {
        if(userValidation(userDetail)) {
            dispatch(requestShowLoader());
            const {selectedCompany,...restParams} = userDetail
            const reqObject = {
            ...restParams,
            "mobile" : userDetail?.phone,
            "userEmail": userDetail?.email,
            "managerId" : userDetail?.selectedManager?.id,
            "userName": userDetail?.email,
            "clientId": userDetail?.selectedCompany?.id,
            "validFrom":userDetail?.validFrom,
            "validTo":userDetail?.validTo,
            }
        
            const url = `${process.env.REACT_APP_BASE_URL}users`;
            const responseData = await createRequestData(reqObject, url);
            const userroleurl = `${process.env.REACT_APP_BASE_URL}userroles`;
            if(responseData?.status == 200) {
                const uerRolepayload = {
                    role: {
                        id: selectedRoles?.id        
                    },
                    user: {
                        id: responseData?.data?.id
                    }
                }
                  
                const response = await createRequestData(uerRolepayload, userroleurl);
                // dispatch(requestgetAllUser());
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: 'success'})
                handleEditApplication(responseData?.data?.id)
                
            } else {
           enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
                  } 

            dispatch(requestHideLoader());


        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
            resetRequiredState()
        }
    }

    const handleupdateuser = async(value=false) => {
    
        if(userValidation(userDetail)) {
        if(JSON.stringify(initialUserDetail) == JSON.stringify(userDetail)) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED") , {variant : 'info'});
        return;
    }
        else{
        dispatch(requestShowLoader());
        const reqObject = {
            ...userDetail,
            "managerId" : userDetail?.selectedManager?.id,
            "mobile" : userDetail?.phone,
            "userEmail": userDetail?.email,
            "userName": userDetail?.email,
            "clientId": userDetail?.selectedCompany?.id
        }
        const url = `${process.env.REACT_APP_BASE_URL}users/${currentuserid}`;
        const responseData = await updateRequestData(reqObject,url);
        if(responseData?.status == 200) {
        const filteredcompany = companyList?.find(item => item?.id == responseData?.data?.clientId);
            // dispatch(requestgetAllUser());
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'})
            const updateUser = responseData?.data;
            const { validFrom, validTo, ...rest } = updateUser;
            setUserdetails({
                ...rest,
                "email" : updateUser?.userEmail,
                "phone" : updateUser?.mobile,
                validFrom : updateUser?.validFrom ? dateFormatting(updateUser?.validFrom) : "",
                validTo : updateUser?.validTo ? dateFormatting(updateUser?.validTo) : "",
                selectedCompany : filteredcompany,
        });
            setIntialUserDetail({
                ...rest,
                "email" : updateUser?.userEmail,
                "phone" : updateUser?.mobile,
                validFrom : updateUser?.validFrom ? dateFormatting(updateUser?.validFrom) : "",
                validTo : updateUser?.validTo ? dateFormatting(updateUser?.validTo) : "",
                selectedCompany : filteredcompany,
            })
            dispatch(requestHideLoader());
            if(value==true){
                 handleCustomBackbutton()
            }
        }
        else{
           enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
        dispatch(requestHideLoader());
        }
    }}

    else {
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
        resetRequiredState()
    }   
    }

    const handleRequestDeleteUserRole = async(id) => {
        const url = `${process.env.REACT_APP_BASE_URL}userroles/${id}`;
        const responseData = await requestDeleteApiCall(url);

        if(responseData?.status) {
            const token = localStorage.getItem('accessToken');
            await getcurrentUserrolesdetails();
            await dispatch(requestgetcurrenctuser(token));
          
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"), {variant: "success"})
        }
    }

    const handleDelete = (id) => async() => {
        if(iscreateuser) {
            const deletedDatagrid = dataGridData?.filter(item => item?.id != id );
            setdataGridData(deletedDatagrid);
        }

        if(isEdituser) {
            handleRequestDeleteUserRole(id)
        }

    }

    const columns = [
        ...(isUserScreen ?[
        {
          field: 'actions',
          type : 'actions',
          headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
          width: 100,
          getActions: ({ id }) => {
           
            return [
              <GridActionsCellItem
                icon={<img src={(isViewMode) ? disabledDeleteIcon : deleteIcon} />}
                label="Edit"
                className="textPrimary"
                disabled = {isViewMode}
                onClick={handleDelete(id)}
                color="inherit"
              />
            ];
          },
        },]
        : []),
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_EDIT_ROLE_NAME'),
          flex: 1,
          editable: false ,
        },
    ];


    const handleChangeCompanyDetails = (event) => {
     const { name, value} = event.target;
      setUserdetails({
          ...userDetail,
          [name]: value
      });
      };


    const handleRequestAddUserRole = async() => {
        
        const url = `${process.env.REACT_APP_BASE_URL}userroles`;
        const rolepermission = {};
        rolepermission["user"] = {id: currentuserid};
        rolepermission["role"] = {id: selectedRoles?.id};
        
        const responseData  = await createRequestData(rolepermission, url); 

        if(responseData?.status == 200) {
            const token = localStorage.getItem('accessToken');
            await getcurrentUserrolesdetails();
            await dispatch(requestgetcurrenctuser(token));
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ADDED_SUCCESSFULLY"), {variant: "success"})
        } 

        if(responseData?.status == 'error') {
           enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
        }
        
    }

    const handleSelectedAddValue = async() => {
        if(iscreateuser) {
            const isExist = dataGridData?.filter(item => item?.roleId == selectedRoles?.id);
            if(isExist.length > 0 ) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ALREADY_ADDED"), {variant: "warning"})
            } else {
                setdataGridData([selectedRoles]);
            
        }
        
        } 

        if(isEdituser) {
            const isExist = dataGridData?.filter(item => item?.roleId == selectedRoles?.id);
            
            if(isExist.length > 0 ) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ALREADY_ADDED"), {variant: "warning"})
            } else {
                handleRequestAddUserRole();
            }
            
            setSelectedRoles(null);
       
        }

        // setSelectedRoles(null);
       
    }

    const handleSelectCompany = (event, Company , value) => {
        switch(value){
     case 'Company':
            setUserdetails({
                ...userDetail,
                selectedCompany: Company,
            });
            break;

        case 'Manager':
            setUserdetails({
                ...userDetail,
                selectedManager: Company,
            });
            break;
            default : 
            break;
        }
    }


    const handleRegeneratePassword = async() => {
        try {
            
            dispatch(requestShowLoader());
           
            const url = `${process.env.REACT_APP_BASE_URL}users/forgotPassword/${currentuserid}`;
           
            const responseData = await updateOrderRequestData({}, url);
            
            await getcurrentuserdetails();
            
            if(responseData?.status == 200) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"PASSWORD_REGEN_SUCCESS"), {variant: "success"}); 
            }

            dispatch(requestHideLoader())
            
        } catch(error) {
            console.log("error", error);
           enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
}
            dispatch(requestHideLoader())
        }

    const handleExpandOrCollapse = (event, exp) => {
            if(exp) {
                const payload = {
                    entityId: currentuserid,
                    entity: getEntityList({entity: "CONFIGURATION_USER_MENU"})
                }
        }
    }
   

    return (
        <React.Fragment>
            <Box sx={{marginBottom: 0, padding: "20px", marginTop: "20px",
                height: "calc(100vh - 131px)",
                overflow: "auto",
                '& .MuiTextField-root': { m: 1, width: '30ch', marginTop: 1 },
                }}>
            {/* <Typography variant='h6'>
                        {isEdituser ? handleValidateCodevalue(internationalise,'USER_EDIT_TITLE_EDIT') : handleValidateCodevalue(internationalise,'CONF_USER_EDIT_TITLE_CREATE')}
            </Typography> */}
            
                <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'CONF_USER_EDIT_DETAILS')}
                </StyledSubHeader>
                    
                <StyledCompanyContainer>
                    {isEdituser && 
                        <TextFiledWithLabel
                required={false}
                name= "id"
                disabled="true"
                value = {userDetail?.id}
                label = {handleValidateCodevalue(internationalise,'CONF_USER_EDIT_ID')}
            />}
            {isUserScreen &&
                    <AutoCompleteComponent
                    isViewMode = {isViewMode}
                    optionSet = {companyList}
                    value={userDetail?.selectedCompany || null}
                    name = "clientId"
                    placeholder={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_CLIENT')}
                    error={userDetail?.selectedCompany?.id ? false : requiredValue?.clientId}
                    required={true}
                    label={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_CLIENT')}       
                    onChange={(e, val) => handleSelectCompany(e, val, "Company")}
                    />
            }
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        required={true}
                        name= "status"
                        disabled ={isEdituser ? isViewMode : true}
                        error={userDetail?.status ? false : requiredValue?.status}
                        value= {userDetail?.status}
                        isStatic = {false}
                        optionMenuItem={userStatusData}
                        label={handleValidateCodevalue(internationalise,'USER_STATUS')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    
                    {(!isEdituser || !isUserScreen)&& 
                    <>
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}
                    />
                    </>}
                    
                    {(isEdituser && isUserScreen) && 
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}
                    />
                    }
                </StyledCompanyContainer>
                
                <StyledCompanyContainer>
                    <SelectBoxWithLabel
                        required={true}
                        name= "title"
                        disabled ={isViewMode}
                        error={userDetail?.title ? false : requiredValue?.title}
                        value= {userDetail?.title ? userDetail?.title : ''}
                        label={handleValidateCodevalue(internationalise,'COMMON_TITLE')}
                        optionMenuItem={commonTitles}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        required={true}
                        name= "firstName" 
                        disabled ={isViewMode}
                        error={userDetail?.firstName ? false : requiredValue?.firstName}
                        value= {userDetail?.firstName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_FIRSTNAME')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        required={true}
                        name= "lastName"
                        disabled ={isViewMode}
                        error={userDetail?.lastName ? false : requiredValue?.lastName}
                        value= {userDetail?.lastName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_LASTNAME')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}
                    />
                 </StyledCompanyContainer>
                  {(isEdituser && isUserScreen) && 
            <WhoColumnTextfieds
            entityDetails={userDetail}
            />}
                {/* <StyledNormalContent>
                    <SelectBoxWithLabel
                        required={false}
                        name= "status"
                        value= {userDetail?.status}
                        optionMenuItem={[{label:"Saved"}, {label:"Archived"}]}
                        label="Status"
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    {!isEdituser && <TextFiledWithLabel
                        required={true}
                        type="password"
                        style={{marginLeft: "60px"}}
                        name= "userPassword"
                        error={userDetail?.userPassword ? false : requiredValue?.userPassword }
                        value= {userDetail?.userPassword}
                        label="Password"
                        handleOnChange={handleChangeCompanyDetails}
                    />}
                </StyledNormalContent> */}
               <CommonComm
                required= {true}
                isDetailPage = {true}
                isViewMode={isViewMode}
                requiredValue={requiredValue}
                handleOnChange={handleChangeCompanyDetails}
                state = {userDetail}
               />
                {/* <StyledCompanyContainer>
                    <SelectBoxWithLabel
                        required={false}
                        name= "language"
                        value= {userDetail?.language}
                        optionMenuItem ={[{label: "Hindi"}, {label: "English"}]}
                        label={handleValidateCodevalue(internationalise,'CONFIGURATION_USER_LANGUAGE')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                </StyledCompanyContainer> */}
                
                <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'CONF_USER_EDIT_VALIDITY')}
                </StyledSubHeader>
                <StyledflexSpacebetween>
                    <div className='date-container-search'>
                    <TextFiledWithLabel
                        required={true}
                        id="updatedatefrom"
                        label={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_VF')}
                        type="date"
                        name="validFrom"
                        disabled ={isViewMode}
                        error={userDetail?.validFrom? false : requiredValue?.validFrom}
                        value={userDetail?.validFrom}    
                        sx={{ width: 220 }}
                       inputProps={{
                       ...(userDetail?.selectedCompany
                    ? { min: moment(userDetail?.selectedCompany?.createdAt).format("YYYY-MM-DD") }
                    : { min: moment().format("YYYY-MM-DD") }),
                        }}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        required={true}
                        id="updatedateto"
                        label={handleValidateCodevalue(internationalise,'CONF_USER_EDIT_VT')}
                        type="date"
                        name="validTo"
                        disabled ={isViewMode}
                        error={userDetail?.validTo? false : requiredValue?.validTo}
                        value={userDetail?.validTo}
                        sx={{ width: 220 }}
                        inputProps={{
                        ...(userDetail?.validFrom ? {min: userDetail?.validFrom} : {})
                        }}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    </div>
                </StyledflexSpacebetween>
                <LeadAccordion
                    label={isUserScreen ? handleValidateCodevalue(internationalise,'CONF_USER_ROLE_ASSIGN')
                        : handleValidateCodevalue(internationalise,'PROF_USER_ROLE_ASSIGNED')
                    }
                >
                    <RolePermissionComponenet 
                        isViewMode = {isViewMode}
                        dropdownlist={allrolesData?.filter(item => !dataGridData?.some(dataItem => item?.id == dataItem?.roleId))}
                        selectedaddedValue = {selectedRoles}
                        handleSelectedValue = {handleSelectMultiRoles}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_ROLES')}
                        isEdit = {isEdituser}
                        placeholder={handleValidateCodevalue(internationalise,'CONF_USER_SELECT_ROLE')}
                        dataGridData = {dataGridData}
                        columns = {columns}
                        handleSelectedAddValue = {handleSelectedAddValue}
                    />
                </LeadAccordion>
                
            </Box>
            {isUserScreen &&
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography variant='h6'>
                        {isEdituser ? handleValidateCodevalue(internationalise,"CONF_USER_EDIT_TITLE_EDIT") : handleValidateCodevalue(internationalise,"CONF_USER_EDIT_TITLE_CREATE")}
                    </Typography>
                    <Button className='edit-primary' sx={{margin: "0px 25px 0px 25px"}} variant="outlined" onClick={handleCustomBackbutton}>{handleValidateCodevalue(internationalise,"COMMON_BACK")}</Button>
                        {isViewMode &&  <Box><Button className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,"COMMON_EDIT")} </Button></Box>}
                        {((!isViewMode && isEdituser) || (!isEdituser)) &&
                            <Button className='edit-primary' variant="outlined"  onClick={isEdituser ? handleupdateuser : handleSaveUser}>{handleValidateCodevalue(internationalise,"COMMON_SAVE")}</Button>
                           
                         } {(isEdituser && !isViewMode) &&
                            <Button className='edit-primary' sx={{margin: "0px 25px 0px 25px"}} variant="outlined"  onClick={()=>handleupdateuser(true)}>{handleValidateCodevalue(internationalise,"COMMON_SAVE_AND_EXIT")}</Button>
                        }
                    </Stack>
                    {(isEdituser && !isViewMode) &&
                    <Box sx={{ display: 'flex', flexDirection: 'column' , gap : 2 ,paddingRight : 2}}>
                        <Button className = 'secondry-edit-btn'  variant="outlined" onClick={handleRegeneratePassword}>
                            {handleValidateCodevalue(internationalise,'CONF_USER_REGEN_PW')}
                        </Button>
                    </Box>
                    }
            </CreateLeadFooter>
}
        </React.Fragment>
        
        
    )
}

export default CreateEditUser;